import * as z from 'zod';
import { validaNomeCompleto } from '../../../../utils/ValidaNome';
import { validateCPF } from '../../../../utils/validations';

export const fileSchema = z
  .object({
    file: z
      .instanceof(FileList)
      .nullable()
      .refine(fileList => fileList && fileList.length > 0, {
        message: 'Arquivo é obrigatório',
      }),
  })
  .superRefine((data, ctx) => {
    const fileList = data.file;

    if (fileList) {
      const file = fileList[0];

      if (file.size > 5000000) {
        ctx.addIssue({
          path: ['file'],
          message: 'Tamanho máximo de 5MB',
          code: z.ZodIssueCode.custom,
        });
      }

      if (!['image/jpeg', 'application/pdf'].includes(file.type)) {
        ctx.addIssue({
          path: ['file'],
          message: 'Somente arquivos JPEG ou PDF são permitidos',
          code: z.ZodIssueCode.custom,
        });
      }
    }
  });

export const BeneficiarySchema = z.object({
  fullName: z
    .optional(z.string().min(1, { message: 'Campo obrigatório' }))
    .refine(val => validaNomeCompleto(val), {
      message: 'Digite o nome completo sem abreviações (ex: João da Silva)',
    }),
  phone: z.optional(
    z.string().min(15, { message: 'O campo requer 15 caracteres' }),
  ),
  email: z.optional(
    z
      .string()
      .min(1, { message: 'Campo obrigatório' })
      .email({ message: 'E-mail inválido' }),
  ),
  gender: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
  civilStatus: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
  firstMothersName: z.optional(
    z.string().min(1, { message: 'Campo obrigatório' }),
  ),
  fullMothersName: z.optional(
    z
      .string()
      .min(1, { message: 'Campo obrigatório' })
      .refine(val => validaNomeCompleto(val), {
        message: 'Digite o nome completo sem abreviações (ex: João da Silva)',
      }),
  ),

  address: z.optional(
    z.object({
      cep: z.optional(z.string().min(9, { message: 'Requer 9 caracteres' })),
      uf: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
      city: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
      neighborhood: z.optional(
        z.string().min(1, { message: 'Campo obrigatório' }),
      ),
      street: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
      number: z.optional(
        z
          .string()
          .min(1, { message: 'Campo obrigatório' })
          .regex(/^\d+$/, { message: 'Deve conter apenas números' }),
      ),
      complement: z.optional(z.string()),
    }),
  ),

  documents: z.optional(
    z.object({
      cns: z.optional(z.string()),
      cpf: z.optional(
        z
          .string()
          .min(14, { message: 'Requer 14 caracteres' })
          .refine(val => validateCPF(val.replace(/\D/g, '')), {
            message: 'CPF inválido',
          }),
      ),
      rg: z.optional(
        z
          .string()
          .min(1, { message: 'Campo obrigatório' })
          .regex(/^[0-9]{1,2}\.?[0-9]{3}\.?[0-9]{3}-?[0-9a-zA-Z]{1,2}$/, {
            message: 'RG inválido',
          }),
      ),
      issuingAgency: z.optional(
        z.string().min(1, { message: 'Campo obrigatório' }),
      ),
      uf: z.string().min(1, { message: 'Campo obrigatório' }),
      ufIssuingAgency: z.string().min(1, { message: 'Campo obrigatório' }),
    }),
  ),
  CNPJCard: fileSchema.optional(),
  CSMei: fileSchema.optional(),
});
